import { keyDown, cut, paste, copy, clearCopy, performUndoRedo, initiateHyperlink, editHyperlink } from '../common/index';
import { findDlg, gotoDlg } from '../common/index';
import { setCellFormat, textDecorationUpdate, getCellIndexes } from '../../workbook/common/index';
import { setCell } from '../../workbook/base/cell';
import { isNullOrUndefined, closest } from '@syncfusion/ej2-base';
/**
 * Represents keyboard shortcut support for Spreadsheet.
 */
var KeyboardShortcut = /** @class */ (function () {
    /**
     * Constructor for the Spreadsheet Keyboard Shortcut module.
     * @private
     */
    function KeyboardShortcut(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    KeyboardShortcut.prototype.addEventListener = function () {
        this.parent.on(keyDown, this.keyDownHandler, this);
    };
    KeyboardShortcut.prototype.removeEventListener = function () {
        if (!this.parent.isDestroyed) {
            this.parent.off(keyDown, this.keyDownHandler);
        }
    };
    KeyboardShortcut.prototype.keyDownHandler = function (e) {
        if (e.ctrlKey) {
            if (!closest(e.target, '.e-find-dlg')) {
                if ([79, 83, 65].indexOf(e.keyCode) > -1) {
                    e.preventDefault();
                }
            }
            if (e.keyCode === 79) {
                this.parent.element.querySelector('#' + this.parent.element.id + '_fileUpload').click();
            }
            else if (e.keyCode === 83) {
                if (this.parent.saveUrl && this.parent.allowSave) {
                    this.parent.save();
                }
            }
            else if (e.keyCode === 67) {
                this.parent.notify(copy, { promise: Promise });
            }
            else if (e.keyCode === 75) {
                var sheet = this.parent.getActiveSheet();
                var indexes = getCellIndexes(sheet.activeCell);
                var row = this.parent.sheets[this.parent.getActiveSheet().id - 1].rows[indexes[0]];
                var cell = void 0;
                e.preventDefault();
                if (!isNullOrUndefined(row)) {
                    cell = row.cells[indexes[1]];
                }
                if (isNullOrUndefined(cell)) {
                    setCell(indexes[0], indexes[1], this.parent.getActiveSheet(), cell, false);
                }
                if (cell && cell.hyperlink) {
                    this.parent.notify(editHyperlink, null);
                }
                else {
                    this.parent.notify(initiateHyperlink, null);
                }
            }
            else if (e.keyCode === 90) { /* Ctrl + Z */
                if (!this.parent.isEdit) {
                    e.preventDefault();
                    this.parent.notify(performUndoRedo, { isUndo: true });
                }
            }
            else if (e.keyCode === 89) { /* Ctrl + Y */
                if (!this.parent.isEdit) {
                    e.preventDefault();
                    this.parent.notify(performUndoRedo, { isUndo: false });
                }
            }
            if (!this.parent.getActiveSheet().isProtected) {
                if (e.keyCode === 70) {
                    e.preventDefault();
                    var toolBarElem = document.querySelector('.e-spreadsheet-find-ddb');
                    if (!isNullOrUndefined(toolBarElem)) {
                        toolBarElem.click();
                    }
                }
                else if (e.keyCode === 71) {
                    e.preventDefault();
                    this.parent.notify(gotoDlg, null);
                }
                else if (e.keyCode === 72) {
                    e.preventDefault();
                    this.parent.notify(findDlg, null);
                }
                else if (e.keyCode === 88) {
                    this.parent.notify(cut, { promise: Promise });
                }
                else if (e.keyCode === 86) {
                    this.parent.notify(paste, { isAction: true });
                }
                else if (e.keyCode === 66) {
                    e.preventDefault();
                    var value = this.parent.getCellStyleValue(['fontWeight'], getCellIndexes(this.parent.getActiveSheet().activeCell)).fontWeight;
                    value = value === 'bold' ? 'normal' : 'bold';
                    this.parent.notify(setCellFormat, { style: { fontWeight: value }, onActionUpdate: true, refreshRibbon: true });
                }
                else if (e.keyCode === 73) {
                    e.preventDefault();
                    var value = this.parent.getCellStyleValue(['fontStyle'], getCellIndexes(this.parent.getActiveSheet().activeCell)).fontStyle;
                    value = value === 'italic' ? 'normal' : 'italic';
                    this.parent.notify(setCellFormat, { style: { fontStyle: value }, onActionUpdate: true, refreshRibbon: true });
                }
                else if (e.keyCode === 85) {
                    e.preventDefault();
                    this.parent.notify(textDecorationUpdate, { style: { textDecoration: 'underline' }, refreshRibbon: true });
                }
                else if (e.keyCode === 53) {
                    e.preventDefault();
                    this.parent.notify(textDecorationUpdate, { style: { textDecoration: 'line-through' }, refreshRibbon: true });
                }
                if (e.shiftKey) {
                    if (e.keyCode === 76) { /* Ctrl + Shift + L */
                        if (!this.parent.isEdit) {
                            e.preventDefault();
                            this.parent.applyFilter();
                        }
                    }
                }
            }
        }
        if (e.keyCode === 27) {
            this.parent.notify(clearCopy, null);
        }
    };
    KeyboardShortcut.prototype.getModuleName = function () {
        return 'keyboardShortcut';
    };
    KeyboardShortcut.prototype.destroy = function () {
        this.removeEventListener();
        this.parent = null;
    };
    return KeyboardShortcut;
}());
export { KeyboardShortcut };
